//#region IMPORTS
import { useEffect, useState } from "react";
import { useAppSelector } from "../../store/configureStore";
import { StoreDetail } from "../../models/store";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import StoreDetailsContainer from "../../components/storeDetails/StoreDetailsContainer";
import useAdminManager from "../../hooks/useAdminManager";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import MainContainer from "../../components/_layout/MainContainer";
import GoBackButton from "../../components/genericButtons/goBackButton/GoBackButton";
import PageHeader from "../../components/genericPageHeader/PageHeader";
import agent from "../../api/agent";
//#endregion

export default function StoreDetails() {
  //#region SETUP
  // Router
  const { id } = useParams<{ id: string }>();

  // Redux
  const { user } = useAppSelector((state) => state.account);

  // Local State
  const isAdmin = useAdminManager(user);
  const [loading, setLoading] = useState(true);
  const [store, setStore] = useState<StoreDetail>();
  //#endregion

  //#region LOGIC
  // Fetch ShopDetail
  useEffect(() => {
    const fetchStoreDetail = async () => {
      setLoading(true);
      try {
        const { data } = await agent.StoreManagement.detail(parseInt(id));
        setStore(data);
        setLoading(false);
      } catch (error) {
        toast.error(`${error}`);
        setLoading(false);
      }
    };
    id && fetchStoreDetail();
  }, [id]);

  //#endregion
  if (loading) return <LoadingSpinner />;
  if (!store && !loading) return <h1>No store found</h1>;

  return store ? (
    <MainContainer>
      <PageHeader title={store?.store_name || "detail"} isAdmin={isAdmin}>
        <GoBackButton />
      </PageHeader>

      <section className="store-page__content">
        <StoreDetailsContainer store={store} />
      </section>
    </MainContainer>
  ) : null;
}
